// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imitate-panel[data-v-750bb968]{position:fixed;top:0;left:0;width:300px;background-color:#212529;color:#fff;z-index:9999;border-bottom-right-radius:.25rem;box-shadow:0 .75rem 1.5rem rgba(18,38,63,.03);overflow-wrap:anywhere}", ""]);
// Exports
module.exports = exports;
